import { useEffect, useRef } from 'react';

import { Text } from '@components/text';
import { TranslationsOverride, useScopedTranslate } from '@locale/translate';

export type MaxLengthCounterProps = TranslationsOverride<typeof translations> & {
  currentLength: number;
  maxLength: number;
  onExceedStatusChange?: (hasExceededLimit: boolean) => void;
};

export const MaxLengthCounter = ({
  currentLength,
  maxLength,
  translationsOverride,
  onExceedStatusChange,
}: MaxLengthCounterProps) => {
  const { t } = useScopedTranslate(translations, translationsOverride);
  const isTooLong = currentLength > maxLength;
  const text = `${currentLength} / ${maxLength} ${t('max')}${isTooLong ? ` • ${t('error')}` : ''}`;
  const previousExceedStateRef = useRef<boolean>(false);

  useEffect(() => {
    if (previousExceedStateRef.current !== isTooLong && onExceedStatusChange) {
      onExceedStatusChange(isTooLong);
    }
    previousExceedStateRef.current = isTooLong;
  }, [isTooLong, onExceedStatusChange]);

  return <Text font="regular14" color={isTooLong ? 'red100' : 'textSecondary'} text={text} />;
};

const translations = {
  is: {
    max: 'Hámarks stafafjöldi',
    error: 'Þú hefur farið yfir hámarks stafafjölda',
  },
  en: {
    max: 'Character limit',
    error: 'You have exceeded the maximum character limit',
  },
};
